import { STYLES_NAME } from '../../../../constants/stylesName/stylesName';
import { getAccordionStyles } from './accordion/styles';
import { getAccordionRowStyles } from './accordionRow/styles';
import { getAccordionSectionStyles } from './accordionSection/styles';
import { getAccordionWithToggleStyles } from './accordionWithToggle/styles';
import { getActionBottomSheetStyles } from './actionBottomSheet/styles';
import { getAmountMaskStyles } from './amountMask/styles';
import { getAmountMaskStylesV2 } from './amountMaskV2/styles';
import { getAsyncImageStyles } from './asyncImage/styles';
import { getAvatarProfileStyles } from './avatarProfile/styles';
import { getBadgeIconStyles } from './badgeIcon/styles';
import { getBadgeLogoStyles } from './badgeLogo/styles';
import { getBadgeNotificationStyles } from './badgeNotification/styles';
import { getBasicCardStyles } from './basicCard/styles';
import { getBreadcrumbStyles } from './breadcrumbs/styles';
import { getBrowserTabsStyles } from './browserTabs/styles';
import { getBubbleStyles } from './bubble/styles';
import { getButtonStyles } from './button/styles';
import { getCalendarStyles } from './calendar/styles';
import { getCallOutAlertStyles } from './callOutAlert/styles';
import { getCardContainerStyles } from './cardContainer/styles';
import { getCardSelectorStyles } from './cardSelector/styles';
import { getCarouselStyles } from './carousel/styles';
import { getChartLegendStyles } from './chartLegend/styles';
import { getCheckboxContainerStyles } from './checkBoxContainer/styles';
import { getCheckboxStyles } from './checkbox/styles';
import { getChipStyles } from './chip/styles';
import { getChipsContainerStyles } from './chipsContainer/styles';
import { getCloseButtonStyles } from './closeButton/styles';
import { getCommercialCardStyles } from './commercialCard/styles';
import { getContextMenuStyles } from './contextMenu/styles';
import { getDataTableStyles } from './dataTable/styles';
import { getDateRangeStyles } from './dateRange/styles';
import { getDocReaderStyles } from './docReader/styles';
import { getDotStyles } from './dot/styles';
import { getDraggableContainerStyles } from './draggableContainer/styles';
import { getDraggableItemStyles } from './draggableItem/styles';
import { getDrawerStyles } from './drawer/styles';
import { getDropdownMultiselectStyles } from './dropdownMultiselect/styles';
import { getEmptyStateStyles } from './emptyState/styles';
import { getErrorTextStyles } from './errorText/styles';
import { getFeedbackButtonStyles } from './feedbackButton/styles';
import { getFileManagerStyles } from './fileManager/styles';
import { getFileUploaderStyles } from './fileUploader/styles';
import { getFloatingButtonStyles } from './floatingButton/styles';
import { getFloatingButtonExtendedStyles } from './floatingButtonExtended/styles';
import { getHeaderStyles } from './header/styles';
import { getIconButtonStyles } from './iconButton/styles';
import { getIconHighlightedStyles } from './iconHighlighted/styles';
import { getInformativeCardStyles } from './informativeCard/styles';
// eslint-disable-next-line @kubit-ui-web/no-index-import/no-index-import
import { getInputStyles } from './input/styles';
import { getInputActionStyles } from './inputAction/styles';
import { getInputBaseStyles } from './inputBase/styles';
import { getInputCurrencyStyles } from './inputCurrency/styles';
import { getInputCurrencyLargeStyles } from './inputCurrencyLarge/styles';
import { getInputDateStyles } from './inputDate/styles';
import { getInputDateIntStyles } from './inputDateInt/styles';
import { getInputDecorationStyles } from './inputDecoration/styles';
import { getInputDigitPasswordStyles } from './inputDigitPassword/styles';
import { getInputDigitSequenceStyles } from './inputDigitSequence/styles';
import { getInputDropdownStyles } from './inputDropdown/styles';
import { getInputErrorMessageStyles } from './inputErrorMessage/styles';
import { getInputHelpMessageStyles } from './inputHelpMessage/styles';
import { getInputLabelStyles } from './inputLabel/styles';
import { getInputPasswordStyles } from './inputPassword/styles';
import { getInputPhoneStyles } from './inputPhone/styles';
import { getInputQuantityStyles } from './inputQuantity/styles';
import { getInputRelatedStyles } from './inputRelated/styles';
import { getInputSearchStyles } from './inputSearch/styles';
import { getInputSearchV2Styles } from './inputSearchV2/styles';
import { getInputSignatureStyles } from './inputSignature/styles';
import { getInputV2Styles } from './inputV2/styles';
import { getInputDateV2Styles } from './inputdateV2/styles';
import { getInsightStyles } from './insight/styles';
import { getKubitNavigationRowStyles } from './kubitNavigationRow/styles';
import { getKubitPillStyles } from './kubitPill/styles';
import { getKubitProgressBar } from './kubitProgressBar/styles';
import { getKubitSelectorBoxFileStyles } from './kubitSelectorBoxFile/styles';
import { getLayoutStyles } from './layout/styles';
import { getLayoutCardStyles } from './layoutCard/styles';
import { getLineSeparatorStyles } from './lineSeparator/styles';
import { getLinkStyles } from './link/styles';
import { getListOptionsStyles } from './listOptions/styles';
import { getLoadMoreContainerStyles } from './loadMoreContainer/styles';
import { getLoaderStyles } from './loader/styles';
import { getLoaderContainerStyles } from './loaderContainer/styles';
import { getMessageStyles } from './message/styles';
import { getModalStyles } from './modal/styles';
import { getModalContainerStyles } from './modalContainer/styles';
import { getNavbarStyles } from './navBar/styles';
import { getNavigationCardStyles } from './navigationCard/styles';
import { getNavigationCardContainerStyles } from './navigationCardContainer/styles';
import { getNavigationRowStyles } from './navigationRow/styles';
import { getNavigationStatusCardStyles } from './navigationStatusCard/styles';
import { getNotificationsStyles } from './notifications/styles';
// eslint-disable-next-line @kubit-ui-web/no-index-import/no-index-import
import { getOptionsStyles } from './option/styles';
import { getOverlayStyles } from './overlay/styles';
import { getPageControlStyles } from './pageControl/styles';
import { getPaginationStyles } from './pagination/styles';
import { getPDFViewerStyles } from './pdfViewer/styles';
import { getPillStyles } from './pill/styles';
import { getPopoverStyles } from './popover/styles';
import { getProductCardStyles } from './productCard/styles';
import { getProgressBarComplexStyles } from './progressBarComplex/styles';
import { getQuickButtonComplexStyles } from './quickButtonComplex/styles';
import { getQuickButtonContainerStyles } from './quickButtonContainer/styles';
import { getRadioButtonGroupStyles } from './radioButtonGroup/styles';
import { getRadioButtonGroupStylesV2 } from './radioButtonGroupV2/styles';
import { getRangeGroupStyles } from './rangeGroup/styles';
import { getRatingStyles } from './rating/styles';
import { getRiskIndexStyles } from './riskIndex/styles';
import { getRiskIndexCNMVStyles } from './riskIndexCNMV/styles';
import { getRiskLevelBarStyles } from './riskLevelBar/styles';
import { getSegmentedControlStyles } from './segmentedControl/styles';
import { getSelectStyles } from './select/styles';
import { getSelectionIndicatorStyles } from './selectionIndicator/styles';
import { getSelectorCardContentStyles } from './selectorCardContent/styles';
import { getSelectorCardExpanderStyles } from './selectorCardExpander/styles';
import { getSelectorCardImageStyles } from './selectorCardImage/styles';
import { getSelectorCardOperativeStyles } from './selectorCardOperative/styles';
import { getSelectiorRowStyles } from './selectorRow/styles';
import { getSelectorRowAgendaStyles } from './selectorRowAgenda/styles';
import { getSelectorRowStyles } from './selectorRowV2/styles';
import { getSkeletonStyles } from './skeleton/styles';
import { getSliderStyles } from './slider/styles';
import { getSnackbarStyles } from './snackbar/styles';
import { getStackableCardStyles } from './stackableCard/styles';
import { getStackableRowStyles } from './stackableRow/styles';
import { getStepperStyles } from './stepper/styles';
import { getSummaryCardStyles } from './summaryCard/styles';
import { getSwitchCardStyles } from './switchCard/styles';
import { getTabFabStyles } from './tabFab/styles';
import { getTableStyles } from './table/styles';
import { getTableBodyStyles } from './tableBody/styles';
import { getTableCaptionStyles } from './tableCaption/styles';
import { getTableCellStyles } from './tableCell/styles';
import { getTableDividerStyles } from './tableDivider/styles';
import { getTableFootStyles } from './tableFoot/styles';
import { getTableHeadStyles } from './tableHead/styles';
import { getTableRowStyles } from './tableRow/styles';
import { getTabStyles } from './tabs/styles';
import { getTabsStyles } from './tabsV2/styles';
import { getTagStyles } from './tag/styles';
import { getTextAreaStyles } from './textArea/styles';
import { getTextCountStyles } from './textCount/styles';
import { getTextCountV2Styles } from './textCountV2/styles';
import { getThirdPartyAnimationSizeStyles, getThirdPartyAnimationStyles, } from './thirdPartyAnimation/styles';
import { getToggleStyles } from './toggle/styles';
import { getToggleWithLabelStyles } from './toggleWithLabel/styles';
import { getTooltipStyles } from './tooltip/styles';
import { getValidationStatusStyles } from './validationStatus/styles';
import { getVirtualKeyboardStyles } from './virtualKeyboard/styles';
export const getComponentsStyles = (FOUNDATIONS, FONT, ANIMATIONS, FONT_FAMILY, SHADOWS) => ({
    [STYLES_NAME.BUTTON]: {
        ...getButtonStyles(FOUNDATIONS, FONT),
    },
    [STYLES_NAME.DOT]: getDotStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.CHECKBOX]: getCheckboxStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.LINK]: getLinkStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.RADIO_BUTTON_GROUP]: getRadioButtonGroupStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.CHIP]: getChipStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.TEXTAREA]: getTextAreaStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.TEXT_COUNT]: getTextCountStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.TEXT_COUNT_V2]: getTextCountV2Styles(FOUNDATIONS, FONT),
    [STYLES_NAME.SNACKBAR]: getSnackbarStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.POPOVER]: getPopoverStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.TOGGLE]: getToggleStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.TOGGLE_WITH_LABEL]: getToggleWithLabelStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.ICON_HIGHLIGHTED]: getIconHighlightedStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.BADGE]: getBadgeNotificationStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.POPOVER]: getPopoverStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.NAVIGATION_ROW]: getKubitNavigationRowStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.NAVIGATION_ROW_PRODUCT]: getNavigationRowStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.COMMERCIAL_CARD]: getCommercialCardStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.LINE_SEPARATOR]: getLineSeparatorStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.MESSAGE]: {
        ...getMessageStyles(FOUNDATIONS, FONT),
    },
    [STYLES_NAME.CALL_OUT_ALERT]: getCallOutAlertStyles(FOUNDATIONS, FONT, SHADOWS),
    [STYLES_NAME.ERROR_TEXT]: getErrorTextStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.ACCORDION]: getAccordionStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.TAG]: getTagStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.SLIDER]: getSliderStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.PAGE_CONTROL]: getPageControlStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.SELECTOR_CARD_EXPANDER]: getSelectorCardExpanderStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.SELECTOR_CARD_IMAGE]: getSelectorCardImageStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.LOADER_CONTAINER]: getLoaderContainerStyles(FOUNDATIONS),
    [STYLES_NAME.THIRD_PARTY_ANIMATION]: getThirdPartyAnimationStyles(ANIMATIONS),
    [STYLES_NAME.QUICK_BUTTON_CONTAINER]: getQuickButtonContainerStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.SELECTION_INDICATOR]: getSelectionIndicatorStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.INFORMATIVE_CARD]: getInformativeCardStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.BADGE_LOGO]: getBadgeLogoStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.QUICK_BUTTON_COMPLEX]: getQuickButtonComplexStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.NAVIGATION_CARD_BANK]: getNavigationCardStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.NAVIGATION_CARD_CONTAINER]: getNavigationCardContainerStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.SELECTOR_CARD_CONTENT]: getSelectorCardContentStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.CHART_LEGEND]: getChartLegendStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.SELECTOR_ROW_AGENDA]: getSelectorRowAgendaStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.SWITCH_CARD]: getSwitchCardStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.BREADCRUMB]: getBreadcrumbStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.AVATAR_PROFILE]: getAvatarProfileStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.NAVIGATION_STATUS_CARD]: getNavigationStatusCardStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.STACKABLE_CARD]: getStackableCardStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.SUMMARY_CARD]: getSummaryCardStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.DRAGGABLE_ITEM]: getDraggableItemStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.DRAGGABLE_CONTAINER]: getDraggableContainerStyles(FOUNDATIONS, FONT, SHADOWS),
    [STYLES_NAME.HEADER]: getHeaderStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.SKELETON]: getSkeletonStyles(FOUNDATIONS),
    [STYLES_NAME.NAVBAR]: getNavbarStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.INPUT_CURRENCY]: getInputCurrencyStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.INPUT_PASSWORD]: getInputPasswordStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.PROGRESS_BAR_COMPLEX]: getProgressBarComplexStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.PROGRESS_BAR]: getKubitProgressBar(FOUNDATIONS, FONT),
    [STYLES_NAME.INPUT_DIGIT_PASSWORD]: getInputDigitPasswordStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.INPUT_QUANTITY]: getInputQuantityStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.INPUT]: getInputStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.INPUT_V2]: getInputV2Styles(FOUNDATIONS, FONT),
    [STYLES_NAME.INPUT_SEARCH_V2]: getInputSearchV2Styles(FOUNDATIONS, SHADOWS, FONT),
    [STYLES_NAME.INPUT_ERROR_MESSAGE]: getInputErrorMessageStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.INPUT_HELP_MESSAGE]: getInputHelpMessageStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.EMPTY_STATE]: getEmptyStateStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.INPUT_DECORATION]: getInputDecorationStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.INPUT_LABEL]: getInputLabelStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.INPUT_BASE]: getInputBaseStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.INPUT_CURRENCY_LARGE]: getInputCurrencyLargeStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.INPUT_ACTION]: getInputActionStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.OVERLAY]: getOverlayStyles(FOUNDATIONS),
    [STYLES_NAME.INPUT_SIGNATURE]: getInputSignatureStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.CLOSE_BUTTON]: getCloseButtonStyles(FOUNDATIONS, FONT, SHADOWS),
    [STYLES_NAME.OPTION]: getOptionsStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.LIST_OPTIONS]: getListOptionsStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.INPUT_DIGIT_SEQUENCE]: getInputDigitSequenceStyles(FOUNDATIONS, FONT, FONT_FAMILY),
    [STYLES_NAME.TOOLTIP]: getTooltipStyles(FOUNDATIONS, FONT, SHADOWS),
    [STYLES_NAME.SEGMENTED_CONTROL]: getSegmentedControlStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.ACTION_BOTTOM_SHEET]: getActionBottomSheetStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.INPUT_SEARCH]: getInputSearchStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.INMPUT_DROPDOWN]: getInputDropdownStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.LOADER]: getLoaderStyles(FOUNDATIONS),
    [STYLES_NAME.CAROUSEL]: getCarouselStyles(FOUNDATIONS),
    [STYLES_NAME.MODAL_CONTAINER]: getModalContainerStyles(FOUNDATIONS, FONT, SHADOWS),
    [STYLES_NAME.INPUT_PHONE]: getInputPhoneStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.ACCORDION_WITH_TOGGLE]: getAccordionWithToggleStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.RANGE_GROUP]: getRangeGroupStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.INPUT_DATE]: getInputDateStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.INPUT_DATE_INT]: getInputDateIntStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.CALENDAR]: getCalendarStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.VALIDATION_STATUS]: getValidationStatusStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.CHIPS_CONTAINER]: getChipsContainerStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.BUBBLE]: getBubbleStyles(FOUNDATIONS, FONT, SHADOWS),
    [STYLES_NAME.BASIC_CARD]: getBasicCardStyles(FOUNDATIONS, FONT, SHADOWS),
    [STYLES_NAME.DRAWER]: getDrawerStyles(FOUNDATIONS, FONT, SHADOWS),
    [STYLES_NAME.LOADER_SIZE]: getThirdPartyAnimationSizeStyles(FOUNDATIONS),
    [STYLES_NAME.TABLE_CELL]: getTableCellStyles(FOUNDATIONS, FONT, FONT_FAMILY),
    [STYLES_NAME.TABLE_ROW]: getTableRowStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.TABLE_HEAD]: getTableHeadStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.TABLE_BODY]: getTableBodyStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.TABLE_FOOT]: getTableFootStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.TABLE_CAPTION]: getTableCaptionStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.TABLE_DIVIDER]: getTableDividerStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.TABLE]: getTableStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.DATA_TABLE]: getDataTableStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.CHECKBOX_CONTAINER]: getCheckboxContainerStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.ICON_BUTTON]: getIconButtonStyles(FOUNDATIONS, SHADOWS),
    [STYLES_NAME.PRIMARY_TABS]: getTabStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.INPUT_RELATED]: getInputRelatedStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.LOAD_MORE_CONTAINER]: getLoadMoreContainerStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.INSIGHT]: getInsightStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.STEPPER]: getStepperStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.STACKABLE_ROW]: getStackableRowStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.PDF_VIEWER]: getPDFViewerStyles(FOUNDATIONS, SHADOWS),
    [STYLES_NAME.PILL]: getKubitPillStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.PILL_PRODUCT]: getPillStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.SELECTOR_CARD_OPERATIVE]: getSelectorCardOperativeStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.MODAL]: getModalStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.SELECT]: getSelectStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.CARD_SELECTOR]: getCardSelectorStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.VIRTUAL_KEYBOARD]: getVirtualKeyboardStyles(FOUNDATIONS, FONT, SHADOWS),
    [STYLES_NAME.DOC_READER]: getDocReaderStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.FILE_UPLOADER]: getFileUploaderStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.SELECTOR_BOX_FILE]: getKubitSelectorBoxFileStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.NOTIFICATIONS]: getNotificationsStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.TAB_FAB]: getTabFabStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.FLOATING_BUTTON]: getFloatingButtonStyles(FOUNDATIONS, FONT, SHADOWS),
    [STYLES_NAME.BADGE_ICON]: getBadgeIconStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.CARD_CONTAINER]: getCardContainerStyles(FOUNDATIONS, FONT, SHADOWS),
    [STYLES_NAME.BROWSER_TABS]: getBrowserTabsStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.RADIO_BUTTON_GROUP_V2]: getRadioButtonGroupStylesV2(FOUNDATIONS, FONT),
    [STYLES_NAME.LAYOUT]: getLayoutStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.LAYOUT_CARD]: getLayoutCardStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.PAGINATION]: getPaginationStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.SELECTOR_ROW]: getSelectiorRowStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.SELECTOR_ROW_V2]: getSelectorRowStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.FEEDBACK_BUTTON]: getFeedbackButtonStyles(FOUNDATIONS, FONT, SHADOWS),
    [STYLES_NAME.CONTEXT_MENU]: getContextMenuStyles(FOUNDATIONS, FONT, SHADOWS),
    [STYLES_NAME.PRODUCT_CARD]: getProductCardStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.RISK_INDEX]: getRiskIndexStyles(FOUNDATIONS, FONT, SHADOWS),
    [STYLES_NAME.RATING]: getRatingStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.ACCORDION_ROW]: getAccordionRowStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.FLOATING_BUTTON_EXTENDED]: getFloatingButtonExtendedStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.AMOUNT_MASK]: getAmountMaskStyles(FOUNDATIONS, FONT, SHADOWS),
    [STYLES_NAME.AMOUNT_MASK_V2]: getAmountMaskStylesV2(FOUNDATIONS, FONT, SHADOWS),
    [STYLES_NAME.RISK_LEVEL_BAR]: getRiskLevelBarStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.ACCORDION_SECTION]: getAccordionSectionStyles(FOUNDATIONS, FONT, SHADOWS),
    [STYLES_NAME.RISK_INDEX_CNMV]: getRiskIndexCNMVStyles(FOUNDATIONS, FONT, SHADOWS),
    [STYLES_NAME.DROPDOWN_MULTISELECT]: getDropdownMultiselectStyles(FOUNDATIONS, FONT, SHADOWS),
    [STYLES_NAME.TABS_V2]: getTabsStyles(FOUNDATIONS, FONT, SHADOWS),
    [STYLES_NAME.DATE_RANGE]: getDateRangeStyles(FOUNDATIONS, FONT, SHADOWS),
    [STYLES_NAME.INPUT_DATE_V2]: getInputDateV2Styles(FOUNDATIONS, FONT, SHADOWS),
    [STYLES_NAME.ASYNC_IMAGE]: getAsyncImageStyles(FOUNDATIONS, FONT),
    [STYLES_NAME.FILE_MANAGER]: getFileManagerStyles(FOUNDATIONS, FONT),
});
//# sourceMappingURL=styles.js.map